import React from "react";
import { Link, useLocation } from "react-router-dom";
import phoneIcon from "../../assets/vector/phoneIcon.svg";
import { FaRegHandPointRight } from "react-icons/fa";
import ShareButton from "./ShareButton";

export default function FindStoreContactPerson({ store, reference }) {
  // const routeLocation = useLocation();
  const siteUrl = "https://olineoindia.com/";
  // console.log("routeLocation ", siteUrl);

  return (
    <div ref={reference}>
      <div className="text-decoration-none">
        <span className="d-flex align-items-center">
          <FaRegHandPointRight style={{ color: "black" }} />
          &nbsp;&nbsp;&nbsp;
          <span className="findStoreContactPersonName ">{store.display_name}</span>
        </span>
        <p className="findStoreContactPersonAddress">{store.street_name}</p>
      </div>
      <div className="d-flex align-items-center " style={{ gap: "10px" }}>
        <Link to={`tel:${store.contact_no}`} className="findStoreContactPersonPhone">
          <img alt="phoneIcon" src={phoneIcon} className="findStoreContactPersonIcon" />
          <p className="findStoreContactPersonNumber">{store.contact_no}</p>
        </Link>
        <div>
          <ShareButton store={store} siteUrl={siteUrl} />
        </div>
      </div>
    </div>
  );
}
